module.exports = __webpack_public_path__ + "static/media/6_Determine-Chime-Kit-Placement-and-Route-Wires.e19149b0.svg";